import axios from "axios";

const TOKEN_KEY = "sohelp_access_token";
const REFRESH_KEY = "sohelp_refresh_token";

export function storeTokens(data) {
  if (data?.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
  if (data?.refresh_token) localStorage.setItem(REFRESH_KEY, data.refresh_token);
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem("sso_access_token");
}

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const tok = localStorage.getItem(TOKEN_KEY) || localStorage.getItem("sso_access_token");
  if (tok && !config.headers.Authorization) config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && !original._retried && !url.includes("/auth/")) {
      original._retried = true;
      try {
        refreshing = refreshing ||
          api.post("/auth/refresh", { refresh_token: localStorage.getItem(REFRESH_KEY) })
            .then((r) => { storeTokens(r.data); return r; });
        await refreshing;
        refreshing = null;
        if (original.headers) delete original.headers.Authorization;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (e?.response?.status === 401 && ["Non autenticato", "Token scaduto", "Token non valido", "Utente non trovato"].includes(detail))
    return "Sessione scaduta. Ricarica la pagina e accedi di nuovo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ") || "Dati non validi.";
  if (detail?.msg) return detail.msg;
  return "Qualcosa è andato storto. Riprova.";
}

export default api;
